import { Button, Tabs, Tooltip } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import UserApi from '../../Api/UserApi';
import { User } from '../../Models/User';
import { useAppSelector } from '../../Reducers/store';
import { HiPencilAlt } from 'react-icons/hi';
import ClientApi from '../../Api/ClientApi';
import { Client } from '../../Models/Client';
import { FaInfoCircle } from 'react-icons/fa';
import { Contact } from '../../Models/Contact';
import OrderApi from '../../Api/OrderApi';
import { OrderSearchRequest } from '../../Models/OrderSearchRequest';
import { OrderCustom } from '../../Models/OrderCustom';
import OrderListTable from '../Order/Admin/OrderListTable';

export default function ClientDetail() {
  const { userModel } = useAppSelector((state) => state.user);
  const { id } = useParams();
  const [clientData, setclientData] = useState<Client | null>();
  const [contactsData, setcontactsData] = useState<Contact[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [orderListData, setorderListData] = useState<OrderCustom[]>([]);
  const [formData, setFormData] = useState<OrderSearchRequest>({
    orderStatus: 0,
    clientId: Number(id),
    fromDate: new Date().toISOString().split('T')[0],
    toDate: new Date().toISOString().split('T')[0],
  });

  const getOrderListCustom = () => {
    if (userModel) {
      try {
        setIsLoading(true);
        return OrderApi.getOrderListCustom(formData)
          .then((res) => {
            setorderListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            console.error(err);
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    }
  };
  const getCLient = () => {
    if (id) {
      setIsLoading(true);
      ClientApi.getClient(id)
        .then((res) => {
          setclientData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setclientData(null);
    }
  };
  const getContactsForClient = () => {
    if (id) {
      setIsLoading(true);
      ClientApi.getContactsForClient(id)
        .then((res) => {
          setcontactsData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setclientData(null);
    }
  };

  useEffect(() => {
    getCLient();
    getContactsForClient();
    getOrderListCustom();
  }, [id]);

  function checkAccess() {
    if (clientData && userModel && id) {
      return true;
    }
    return false;
  }

  return (
    <div className='w-full'>
      <div className='w-full p-4'>
        <div className='mx-1 flex items-end'>
          <div className='flex flex-1 gap-3 items-center'>
            <h1 className='text-gray-900 font-bold text-4xl'>Client Details</h1>
            <Tooltip content='Visit Rimss to update Client Details'>
              <FaInfoCircle size={20} />
            </Tooltip>
          </div>
        </div>
      </div>

      <div>
        <div className='container mx-auto p-2'>
          <div className='md:flex no-wrap md:-mx-2 '>
            <div className='w-full mx-2'>
              <div className='bg-white p-3'>
                <div className='flex items-center space-x-2 font-bold text-gray-500 leading-8 py-2'>
                  <span className='tracking-wide uppercase text-3xl'>
                    {clientData?.name}
                  </span>
                </div>
                <hr className='bg-gray-300 h-[5px]'></hr>
                <div className='text-gray-500'>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Territory:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {clientData?.territory?.number ?? ''}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Address:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {clientData?.address ?? ''}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Phone:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {clientData?.phone ?? ''}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Email:</div>
                    </div>
                    <div className='pl-1 text-black'>{clientData?.email}</div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Website:</div>
                    </div>
                    <div className='pl-1 text-black'>{clientData?.website}</div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Rimss Id:</div>
                    </div>
                    <div className='pl-1 text-black'>{clientData?.rimssId}</div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Account #:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {clientData?.accountNumber}
                    </div>
                  </div>
                  <div className='py-2 pt-5'>
                    <Tabs style='fullWidth'>
                      <Tabs.Item title='Contacts' className='font-bold'>
                        {contactsData.map((contact) => (
                          <div className='mb-2'>
                            <div className='font-bold'>
                              {contact.firstName} {contact.lastName}
                            </div>
                            <div>
                              <div className='pl-1 text-black'>
                                Phone: {contact.phone}
                              </div>
                            </div>
                            <div>
                              <div className='pl-1 text-black'>
                                Email: {contact.email}
                              </div>
                            </div>
                          </div>
                        ))}
                      </Tabs.Item>
                      <Tabs.Item title='Orders' className='font-bold'>
                        <OrderListTable data={orderListData} />
                      </Tabs.Item>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
